export default __webpack_public_path__ + "static/impact-photo-emily-b3ca38e97d626ccee4dc5401836d3d32.jpg";